import React from "react";
import Listings from "../modules/Listings.js";

const Projects = () => {
	return <Listings />;
};

export default Projects;